import { useState } from 'react';
import { searchIngredients } from '../../data/index.js';

/**
 * Type-ahead over the catalogue. Picking from the list is what keeps a
 * recipe's mince and the bolognese's mince on ONE shopping line. Anything the
 * catalogue does not have can still be added — as an extra, never as a
 * made-up catalogue entry.
 */
export function IngredientSearch({
  onPick,
  onExtra,
}: {
  onPick: (ingredientId: string) => void;
  onExtra: (label: string) => void;
}): React.JSX.Element {
  const [query, setQuery] = useState('');
  const matches = searchIngredients(query);
  const label = query.trim();

  return (
    <div className="ingredient-search">
      <label className="visually-hidden" htmlFor="ingredient-search">Add an ingredient</label>
      <input
        id="ingredient-search"
        className="search"
        placeholder="Add an ingredient"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={(e) => {
          if (e.key !== 'Enter') return;
          // Enter must not submit the surrounding recipe form.
          e.preventDefault();
          if (label.length === 0) return;
          const first = matches[0];
          if (first) onPick(first.id);
          else onExtra(label);
          setQuery('');
        }}
      />
      {label.length > 0 ? (
        <div className="suggestions">
          {matches.map((ingredient) => (
            <button
              key={ingredient.id}
              type="button"
              onClick={() => {
                onPick(ingredient.id);
                setQuery('');
              }}
            >
              {ingredient.name}
            </button>
          ))}
          <button
            type="button"
            className="ghost"
            onClick={() => {
              onExtra(label);
              setQuery('');
            }}
          >
            Add &quot;{label}&quot; as an extra item
          </button>
        </div>
      ) : null}
    </div>
  );
}
